import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  InputField,
  CheckboxField,
  Form,
  Dropdown,
  SelectField,
} from '@adc/ui-adc'
import classnames from 'classnames/bind'
import { getDefaultFilters } from '../../utils/event.filters'
import STATICS from '../../event.statics'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const isValidYear = value => /^\d{0,4}$/i.test(value)

class AssetFilter extends Component {
  static propTypes = {
    onChangeHandler: PropTypes.func.isRequired,
    elmId: PropTypes.string.isRequired,
    filters: PropTypes.object.isRequired,
    stateList: PropTypes.array.isRequired,
    countyList: PropTypes.array.isRequired,
    cityList: PropTypes.array.isRequired,
    mobileLayout: PropTypes.bool,
  }

  state = {
    errorStatus: {},
    values: getDefaultFilters(),
  }

  propertyTypeChange = (key, nextValue) => {
    const { propertyTypeFilters } = this.props.filters
    const nextPropertyTypeFilters = Object.assign({}, propertyTypeFilters, {
      [key]: nextValue,
    })

    this.filterChange('propertyTypeFilters', nextPropertyTypeFilters)
  }

  filterChange = (key, value) => {
    const nextState = Object.assign({}, this.props.filters, {
      [key]: value,
    })
    this.setState({ values: { ...this.state.values, ...nextState } })
    this.props.onChangeHandler(nextState)
  }

  resetFilters = () => {
    const { onChangeHandler } = this.props
    const nextState = getDefaultFilters()
    this.setState({ values: { ...this.state.values, nextState } })
    onChangeHandler(nextState)
  }

  onInputChange = (e, fieldName) => {
    if (isValidYear(e.target.value)) {
      this.filterChange(fieldName, { value: e.target.value })
      this.setState({
        errorStatus: {
          ...this.state.errorStatus,
          [fieldName]: null,
        },
      })
    } else {
      this.setState({
        errorStatus: {
          ...this.state.errorStatus,
          [fieldName]: 'Please input a valid year',
        },
      })
    }
  }

  onDropDownChange = (e, data) => {
    this.filterChange(data.value.filter, data.value)
  }

  render() {
    const { elmId, filters, stateList, countyList, cityList, mobileLayout } =
      this.props
    const {
      propertyTypeFilters,
      minPrice,
      maxPrice,
      beds,
      baths,
      sqft,
      occupancyStatus,
      yearBuiltFrom,
      yearBuiltTo,
      stateFilter,
      countyFilter,
      cityFilter,
    } = filters
    return (
      <Form
        data-elm-id={`${elmId}_asset_filter`}
        className={cx('filters-container', { 'mobile-layout': mobileLayout })}
      >
        <h3 className={cx('title')} data-elm-id={`${elmId}_filters_title`}>
          {STATICS.FILTERS_TITLE}
        </h3>
        <div className={cx('filter-section')}>
          <h4
            className={cx('property-type-title')}
            data-elm-id={`${elmId}_filters_property_type_title`}
          >
            {STATICS.PROPERTY_TYPE_TITLE}
          </h4>
          <div>
            {STATICS.PROPERTY_TYPE_FILTERS.map(propertyType => (
              <CheckboxField
                onChange={() =>
                  this.propertyTypeChange(
                    propertyType.value,
                    !propertyTypeFilters[propertyType.value]
                  )
                }
                elmId={`${elmId}_filter_property_type_${propertyType.value}`}
                key={`${elmId}_filter_property_type_${propertyType.value}`}
                label={propertyType.label}
                role='info'
                checked={propertyTypeFilters[propertyType.value]}
              />
            ))}
          </div>
        </div>
        <div className={cx('filter-section')}>
          <h4 className={cx('sale-location-title')}>Sale Location</h4>
          <SelectField
            elmId={`${elmId}_filters_state`}
            className={cx('filter-dropdown', 'u-stretch')}
            name={`${elmId}_filters_state`}
            placeholder={stateFilter.label}
            onChange={this.onDropDownChange}
            options={[
              {
                key: STATICS.DEFAULT_STATE_FILTER.value,
                value: {
                  label: STATICS.DEFAULT_STATE_FILTER.label,
                  value: STATICS.DEFAULT_STATE_FILTER.value,
                  filter: 'stateFilter',
                },
                text: STATICS.DEFAULT_STATE_FILTER.label,
                content: (
                  <Dropdown.Item
                    data-elm-id={`${elmId}_filters_state_option_default`}
                    onClick={() =>
                      this.filterChange(
                        'stateFilter',
                        STATICS.DEFAULT_STATE_FILTER
                      )
                    }
                  >
                    {STATICS.DEFAULT_STATE_FILTER.label}
                  </Dropdown.Item>
                ),
              },
              ...stateList.map(state => ({
                key: state.value,
                value: {
                  label: state.label,
                  value: state.value,
                  filter: 'stateFilter',
                },
                text: state.label,
                content: (
                  <Dropdown.Item
                    data-elm-id={`${elmId}_filters_state_option_${state.value}`}
                    key={`${elmId}_filters_state_option_${state.value}`}
                  >
                    {state.label}
                  </Dropdown.Item>
                ),
              })),
            ]}
            value={this.state.values.stateFilter.value}
          />
          <SelectField
            elmId={`${elmId}_filters_county`}
            className={cx('filter-dropdown', 'u-stretch')}
            name={`${elmId}_filters_county`}
            placeholder={countyFilter.label}
            onChange={this.onDropDownChange}
            options={[
              {
                key: STATICS.DEFAULT_COUNTY_FILTER.value,
                value: {
                  label: STATICS.DEFAULT_COUNTY_FILTER.label,
                  value: STATICS.DEFAULT_COUNTY_FILTER.value,
                  filter: 'countyFilter',
                },
                text: STATICS.DEFAULT_COUNTY_FILTER.label,
                content: (
                  <Dropdown.Item
                    data-elm-id={`${elmId}_filters_state_option_default`}
                    onClick={() =>
                      this.filterChange(
                        'countyFilter',
                        STATICS.DEFAULT_COUNTY_FILTER
                      )
                    }
                  >
                    {STATICS.DEFAULT_COUNTY_FILTER.label}
                  </Dropdown.Item>
                ),
              },
              ...countyList.map(county => ({
                key: county.value,
                value: {
                  label: county.label,
                  value: county.value,
                  filter: 'countyFilter',
                },
                text: county.label,
                content: (
                  <Dropdown.Item
                    data-elm-id={`${elmId}_filters_county_option_${county.value}`}
                    key={`${elmId}_filters_county_option_${county.value}`}
                  >
                    {county.label}
                  </Dropdown.Item>
                ),
              })),
            ]}
            value={this.state.values.countyFilter.value}
          />

          <SelectField
            elmId={`${elmId}_filters_city`}
            className={cx('filter-dropdown', 'u-stretch')}
            name={`${elmId}_filters_city`}
            placeholder={cityFilter.label}
            onChange={this.onDropDownChange}
            options={[
              {
                key: STATICS.DEFAULT_CITY_FILTER.value,
                value: {
                  label: STATICS.DEFAULT_CITY_FILTER.label,
                  value: STATICS.DEFAULT_CITY_FILTER.value,
                  filter: 'cityFilter',
                },
                text: STATICS.DEFAULT_CITY_FILTER.label,
                content: (
                  <Dropdown.Item
                    data-elm-id={`${elmId}_filters_state_option_default`}
                  >
                    {STATICS.DEFAULT_CITY_FILTER.label}
                  </Dropdown.Item>
                ),
              },
              ...cityList.map(city => ({
                key: city.value,
                value: {
                  label: city.label,
                  value: city.value,
                  filter: 'cityFilter',
                },
                text: city.label,
                content: (
                  <Dropdown.Item
                    data-elm-id={`${elmId}_filters_city_option_${city.value}`}
                    key={`${elmId}_filters_city_option_${city.value}`}
                  >
                    {city.label}
                  </Dropdown.Item>
                ),
              })),
            ]}
            value={this.state.values.cityFilter.value}
          />
        </div>
        <h4
          data-elm-id={`${elmId}_filters_property_details_title`}
          className={cx('property-details-title')}
        >
          {STATICS.PROPERTY_DETAILS_TITLE}
        </h4>
        <div className={cx('filter-section', 'utk-util-tc')}>
          <strong className={cx('block-label')}>{STATICS.PRICE_TITLE}</strong>
          <SelectField
            elmId={`${elmId}_filters_min_price`}
            className={cx('filter-dropdown', 'u-stretch')}
            name='minPrice'
            placeholder={minPrice.label}
            onChange={this.onDropDownChange}
            options={STATICS.MIN_PRICE.map(price => ({
              key: price.value,
              value: {
                label: price.label,
                value: price.value,
                filter: 'minPrice',
              },
              text: price.label,
              content: (
                <Dropdown.Item
                  elmId={`${elmId}_filters_min_price_option_${price.label}`}
                  key={`${elmId}_filters_min_price_option_${price.label}`}
                >
                  {price.label}
                </Dropdown.Item>
              ),
            }))}
            value={this.state.values.minPrice.value}
          />
          <span className={cx('separator')}>to</span>
          <SelectField
            elmId={`${elmId}_filters_max_price`}
            className={cx('filter-dropdown', 'u-stretch')}
            name='maxPrice'
            placeholder={maxPrice.label}
            onChange={this.onDropDownChange}
            options={STATICS.MAX_PRICE.map(price => ({
              key: price.value,
              value: {
                label: price.label,
                value: price.value,
                filter: 'maxPrice',
              },
              text: price.label,
              content: (
                <Dropdown.Item
                  elmId={`${elmId}_filters_max_price_option_${price.label}`}
                  key={`${elmId}_filters_max_price_option_${price.label}`}
                >
                  {price.label}
                </Dropdown.Item>
              ),
            }))}
            value={this.state.values.maxPrice.value}
          />
        </div>
        <div className={cx('filter-section')}>
          <strong className={cx('block-label')}>{STATICS.BEDS_TITLE}</strong>
          <SelectField
            elmId={`${elmId}_filters_beds`}
            className={cx('filter-dropdown', 'u-stretch')}
            name='maxPrice'
            placeholder={beds.label}
            onChange={this.onDropDownChange}
            options={STATICS.BEDS.map(bed => ({
              key: bed.value,
              value: { label: bed.label, value: bed.value, filter: 'beds' },
              text: bed.label,
              content: (
                <Dropdown.Item
                  elmId={`${elmId}_filters_beds_option_${bed.label}`}
                  key={`${elmId}_filters_beds_option_${bed.label}`}
                >
                  {bed.label}
                </Dropdown.Item>
              ),
            }))}
            value={this.state.values.beds.value}
          />
        </div>
        <div className={cx('filter-section')}>
          <strong className={cx('block-label')}>{STATICS.BATHS_TITLE}</strong>
          <SelectField
            elmId={`${elmId}_filters_baths`}
            className={cx('filter-dropdown', 'u-stretch')}
            name='baths'
            placeholder={baths.label}
            onChange={this.onDropDownChange}
            options={STATICS.BATHS.map(bath => ({
              key: bath.value,
              value: { label: bath.label, value: bath.value, filter: 'baths' },
              text: bath.label,
              content: (
                <Dropdown.Item
                  elmId={`${elmId}_filters_baths_option_${bath.label}`}
                  key={`${elmId}_filters_baths_option_${bath.label}`}
                >
                  {bath.label}
                </Dropdown.Item>
              ),
            }))}
            value={this.state.values.baths.value}
          />
        </div>
        <div className={cx('filter-section')}>
          <strong className={cx('block-label')}>{STATICS.SQFT_TITLE}</strong>
          <SelectField
            elmId={`${elmId}_filters_sqft`}
            className={cx('filter-dropdown', 'u-stretch')}
            name='sqft'
            placeholder={sqft.label}
            onChange={this.onDropDownChange}
            options={STATICS.SQFT.map(sqft => ({
              key: sqft.value,
              value: { label: sqft.label, value: sqft.value, filter: 'sqft' },
              text: sqft.label,
              content: (
                <Dropdown.Item
                  elmId={`${elmId}_filters_baths_option_${sqft.label}`}
                  key={`${elmId}_filters_baths_option_${sqft.label}`}
                >
                  {sqft.label}
                </Dropdown.Item>
              ),
            }))}
            value={this.state.values.sqft.value}
          />
        </div>
        <div className={cx('utk-util-tc')}>
          <strong className={cx('block-label')}>
            {STATICS.YEAR_BUILT_TITLE}
          </strong>
          <div className={cx('input-container', 'u-mb-neg-3')}>
            <InputField
              name='yearBuiltFrom'
              label=''
              placeholder='YYYY'
              elmId={`${elmId}_filters_year_built_from`}
              onChange={e => this.onInputChange(e, 'yearBuiltFrom')}
              value={yearBuiltFrom.value}
              touched
              warning={this.state.errorStatus.yearBuiltFrom}
              className={cx('input-form')}
            />
          </div>
          <span className={cx('separator')}>to</span>
          <div className={cx('input-container')}>
            <InputField
              name='yearBuiltTo'
              label=''
              placeholder='YYYY'
              elmId={`${elmId}_filters_year_built_to`}
              onChange={e => this.onInputChange(e, 'yearBuiltTo')}
              value={yearBuiltTo.value}
              touched
              warning={this.state.errorStatus.yearBuiltTo}
              className={cx('input-form')}
            />
          </div>
        </div>
        <div className={cx('filter-section', 'u-mt-2')}>
          <strong className={cx('block-label')}>
            {STATICS.OCCUPANCY_STATUS_TITLE}
          </strong>
          <SelectField
            elmId={`${elmId}_filters_occupancy_status`}
            className={cx('filter-dropdown', 'u-stretch')}
            name='occupancyStatus'
            placeholder={occupancyStatus.label}
            onChange={this.onDropDownChange}
            options={STATICS.OCCUPANCY_STATUS.map(option => ({
              key: option.value,
              value: {
                label: option.label,
                value: option.value,
                filter: 'occupancyStatus',
              },
              text: option.label,
              content: (
                <Dropdown.Item
                  elmId={`${elmId}_filters_occupancy_status_option_${option.label}`}
                  key={`${elmId}_filters_occupancy_status_option_${option.label}`}
                >
                  {option.label}
                </Dropdown.Item>
              ),
            }))}
            value={this.state.values.occupancyStatus.value}
          />
        </div>
        <Button
          role='default'
          elmId={`${elmId}_reset_filters`}
          onClick={this.resetFilters}
          className={cx('reset-btn')}
          isStretch
        >
          {STATICS.RESET_FILTERS}
        </Button>
      </Form>
    )
  }
}

export default AssetFilter
